<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div v-if="show">
    <vue-plotly :data="plotData" :layout="layout" :options="options" />
  </div>
  <div v-else class="align-center">
    <v-img
      class="align-center"
      max-height="100"
      max-width="65"
      src="/reo_pics/error.png"
    ></v-img>
  </div>
</template>

<script>
  import VuePlotly from '@statnett/vue-plotly';
  import {mapGetters} from 'vuex';
  import {config} from '@/store/config';

  export default {
    name: 'hist_impexpgraph_tm_total',
    components: {
      VuePlotly,
    },
    props: [],
    methods: {
      selected_product() {
        if (
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
            .HS6_Code.length > 0
        ) {
          return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
            .products.HS6_Code[0];
        } else return '';
      },
      target_market() {
        return this.codeToMarket(
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
            .C_Code[0],
        );
      },
    },
    computed: {
      ...mapGetters(['app_data', 'selectionCounts']),
      plotData: function () {
        return [
          {
            y: this.array_value_conversion(
              [
                this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value,
                this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value,
                this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value,
                this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value,
                this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value,
              ],
              null,
            ),

            x: this.$store.getters.historyPlotData['x'],
            name:
              'Estimated untapped potential  (' +
              this.app_data.exchange_rate['Currency'].slice(0, 3) +
              ' ' +
              (
                (this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value /
                  this.app_data.value_mulitplier['divider']) *
                this.app_data.exchange_rate['TW_FX_Rate']
              ).toFixed(2) +
              ' ' +
              this.app_data.value_mulitplier['prefix'] +
              ')',
            type: 'bar',
            marker: {
              color: config.plot_bar_green,
            },
          },
          {
            y: this.array_value_conversion(
              this.$store.getters.historyPlotData['y'][0],
              'time_weighted',
            ),
            x: this.$store.getters.historyPlotData['x'],
            name: `${this.target_market()} imports of ${this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code} <- Wold`,
            mode: 'lines',
            line: {
              color: config.plot_brown,
              width: config.plot_line_width,
              dash: 'dashdot',
            },
          },
          {
            y: this.array_value_conversion(
              this.$store.getters.historyPlotData['y'][1],
              'time_weighted',
            ),
            x: this.$store.getters.historyPlotData['x'],
            name:
              `${this.codeToMarket(
                this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.home_market,
              )} exports of ${this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code} -> ${this.target_market()}`,
            type: 'lines',
            marker: {
              color: [
                config.plot_blue,
                config.plot_blue,
                config.plot_blue,
                config.plot_blue,
                config.plot_blue,
              ],
            },
            mode: 'lines',
            line: {
              color: '#162f7a',
              width: config.plot_line_width,
            },
          },
        ];
      },
      show: function () {
        return this.$store.getters.historyPlotData['x'][0] > 1;
      },
      layout: function () {
        return {
          //paper_bgcolor: '#7f7f7f',
          //plot_bgcolor: '#c7c7c7',
          title: {
            text:
              this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                .products.HS6_Code[0] +
              ' for ' +
              this.target_market() +
              '<br> imports from ' +
              this.codeToMarket(
                this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.home_market,
              ) +
              ' & World',
            font: {
              size: 11,
            },
          },
          height: '300',
          width: '400',
          autosize: true,
          margin: {
            l: 50,
            r: 20,
            b: 60,
            t: 60,
            pad: 2,
          },

          xaxis: {
            tickmode: 'linear',
            fixedrange: true,

            // range: [2016, 2020],
            tickfont: {
              size: 10,
            },
            // automargin: true
          },
          yaxis: {
            title: '',
            fixedrange: true,
            tickfont: {
              size: 10,
            },
            rangemode: 'nonnegative',
             exponentformat:'none'
          },
          legend: {
            orientation: 'h',
            //dict:{x:1, y:2},
            font: {size: 9},
            automargin: true,

            traceorder: 'normal',
          },
          bargap: 0,
          barmode: 'stack',
          annotations: [
            {
              xref: 'paper',
              yref: 'paper',
              x: 0.38,
              y: -0.5,
              xanchor: 'center',
              yanchor: 'top',
              text: config.CEPII_Source,
              showarrow: false,
              font: {
                family: 'Arial',
                size: 8,
                color: 'rgb(150,150,150)',
              },
            },
            {
              x: '0',
              y: '1',
              xref: 'paper',
              yref: 'paper',
              xanchor: 'right',
              yanchor: 'bottom',
              text:
                this.app_data.value_mulitplier['prefix'] +
                ' ' +
                this.app_data.exchange_rate['Currency'].slice(0, 3),
              showarrow: false,
            },
          ],
        };
      },
    },

    data: function () {
      return {
        options: {
          responsive: true,
          displayModeBar: false,
        },
      };
    },
  };
</script>
